import mwcMarketsCore from 'mwc-markets-core';
import Component from './src/research';

const { createCustomElement } = mwcMarketsCore;

export default createCustomElement(Component);
